import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgList = function SvgList(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M2.555 7.031a2.016 2.016 0 100-4.031 2.016 2.016 0 000 4.031zM22.477 4.031H7.523a.99.99 0 00-.984.985c0 .515.469.984.984.984h14.954a.99.99 0 00.984-.984.99.99 0 00-.984-.985zM2.555 14.016a2.016 2.016 0 100-4.032 2.016 2.016 0 000 4.032zM7.523 12.984h9.985a.99.99 0 00.984-.984c0-.516-.469-.984-.984-.984H7.523A.99.99 0 006.54 12a.99.99 0 00.984.984zM2.555 21a2.016 2.016 0 100-4.031 2.016 2.016 0 000 4.031zM20.508 18H7.523a.99.99 0 00-.984.984c0 .516.469.985.984.985h12.938a.99.99 0 00.984-.985c0-.515-.422-.984-.937-.984z"
  }));
};

export default SvgList;